import { Action, combineReducers } from "redux";
import { createReducer, IAction } from "reduxsauce";
import { Types as AllTypes } from "../../actions";
import { IOrganization } from "../../reducers/course-author/types";

export interface IState {
  _: ISelectOrganizationState;
}

export interface ISelectOrganizationState {
  organizations: IOrganization[] | null;
  fetchAllOrganizationsRequestState: FetchAllOrganizationsRequestState;
  fetchAllOrganizationsRequestError: string | null;
}

export enum FetchAllOrganizationsRequestState {
  IDLE = "IDLE",
  PENDING = "PENDING",
  FAILED = "FAILED",
  SUCCEEDED = "SUCCEEDED",
}

const Types = (AllTypes as any)._APP._SELECT_ORGANIZATION;

export const INITIAL_STATE: ISelectOrganizationState = {
  fetchAllOrganizationsRequestError: null,
  fetchAllOrganizationsRequestState: FetchAllOrganizationsRequestState.IDLE,
  organizations: null,
};

export function mount(state: ISelectOrganizationState, action: IAction): ISelectOrganizationState {
  return INITIAL_STATE;
}

export function unmount(state: ISelectOrganizationState, action: IAction): ISelectOrganizationState {
  return INITIAL_STATE;
}

export function fetchAllOrganizations(state: ISelectOrganizationState, action: IAction): ISelectOrganizationState {
  return {
    ...state,
    fetchAllOrganizationsRequestError: null,
    fetchAllOrganizationsRequestState: FetchAllOrganizationsRequestState.PENDING,
  };
}

export function handleFetchAllOrganizationsFailure(
  state: ISelectOrganizationState,
  action: IAction
): ISelectOrganizationState {
  return {
    ...state,
    fetchAllOrganizationsRequestError: action.error.message,
    fetchAllOrganizationsRequestState: FetchAllOrganizationsRequestState.FAILED,
  };
}

export function handleFetchAllOrganizationsSuccess(
  state: ISelectOrganizationState,
  action: IAction
): ISelectOrganizationState {
  return {
    ...state,
    fetchAllOrganizationsRequestError: null,
    fetchAllOrganizationsRequestState: FetchAllOrganizationsRequestState.SUCCEEDED,
    organizations: action.organizations,
  };
}

export default combineReducers<IState, Action>({
  _: createReducer<ISelectOrganizationState>(INITIAL_STATE, {
    [Types.MOUNT]: mount,
    [Types.FETCH_ALL_ORGANIZATIONS]: fetchAllOrganizations,
    [Types.HANDLE_FETCH_ALL_ORGANIZATIONS_FAILURE]: handleFetchAllOrganizationsFailure,
    [Types.HANDLE_FETCH_ALL_ORGANIZATIONS_SUCCESS]: handleFetchAllOrganizationsSuccess,
    [Types.UNMOUNT]: unmount,
  }),
});
